import axios from 'axios';
import { AppConfig } from './../config';


export const GET_PRESIGNED_URL = (data: any): Promise<any> => {
    return axios.post(`https://demo.vyaparlive.com/file`, data);
};

export const GET_SHORT_URL_BY_ID = (data: any): Promise<any> => {
    return axios.get(`${AppConfig.BASE_URL}/notification/short-url/${data}`);
};
